export const firebaseService = {
  initializeMessageHandling(store, router) {
    window.FirebasePlugin.onMessageReceived((message) => {
      try {
        console.log("onMessageReceived", message)
        store.dispatch('readPush', message)
        
        if (message.url && message.tap === 'background') {
          router.push(message.url)
        }
      } catch (e) {
        console.error("Ошибка в обработке сообщения Firebase:", e.message)
      }
    }, (error) => {
      console.error("Ошибка получения сообщения Firebase:", error)
    })
  }
}